import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { AppActionLoaderComponent } from './components/app-action-loader/app-action-loader.component';
import { AppInlineLoaderComponent } from './components/app-inline-loader/app-inline-loader.component';
import { AppItemPendingIndicatorComponent } from './components/app-item-pending-indicator/app-item-pending-indicator.component';
import { AppLoadingDebugPanelComponent } from './components/app-loading-debug-panel/app-loading-debug-panel.component';
import { AppSectionLoaderComponent } from './components/app-section-loader/app-section-loader.component';
import { AppSectionLoaderOverlayComponent } from './components/app-section-loader-overlay/app-section-loader-overlay.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AppFullscreenLoaderOverlayComponent } from './components/app-fullscreen-loader-overlay/app-fullscreen-loader-overlay.component';
import { AppTopLoaderBarComponent } from './components/app-top-loader-bar/app-top-loader-bar.component';
import { AppSectionLoaderHostDirective } from './directives/app-section-loader-host.directive';

@NgModule({
  declarations: [
    AppTopLoaderBarComponent,
    AppFullscreenLoaderOverlayComponent,
    AppLoadingDebugPanelComponent,
    AppInlineLoaderComponent,
    AppActionLoaderComponent,
    AppItemPendingIndicatorComponent,
    AppSectionLoaderOverlayComponent,
    AppSectionLoaderComponent,
    AppSectionLoaderHostDirective,
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
  ],
  exports: [
    AppTopLoaderBarComponent,
    AppFullscreenLoaderOverlayComponent,
    AppLoadingDebugPanelComponent,
    AppInlineLoaderComponent,
    AppActionLoaderComponent,
    AppItemPendingIndicatorComponent,
    AppSectionLoaderComponent,
    AppSectionLoaderHostDirective,
  ],
})
export class LoadingPlatformModule {}
